module.exports = __webpack_public_path__ + "img/computersetup.fb5d34a9.png";